import React from "react";
import { Check, ArrowRight, Minus, CalendarDays, ShieldCheck, X } from "lucide-react";
import VslFooter from "../vsl/VslFooter";
import { trackTelegramClick } from "../../../lib/tracking";

const WA = "https://wa.me/393514197003?text=Ciao+Claudio,+ti+scrivo+per+Sales+Mastery+1.0+—+percorso+";
const BASE = [
  "Accesso a Skool + 200h di formazione esclusiva e mirata",
  "Roadmap concreta",
  "Affiancamento con personal coach",
  "Garanzia sull'affiancamento eseguito",
];
const EXTRA = [
  "Profilo personale sul portale di analisi dedicato",
  "Tutte le sessioni private registrate, disponibili per sempre senza scadenza",
];

const PLANS = [
  {
    id: 1,
    name: "Piano 1",
    duration: "1 Mese",
    price: "€997",
    url: `${WA}mensile.`,
    features: [BASE[0], "4 Call one-to-one da +1h30 l'una", ...BASE.slice(1), ...EXTRA],
  },
  {
    id: 2,
    name: "Piano 2",
    duration: "2 Mesi",
    price: "€1.497",
    url: `${WA}bimestrale.`,
    features: [BASE[0], "6 Call one-to-one da +1h30 l'una", ...BASE.slice(1), "Accesso One-to-Many avanzate con le Classi sopra i 5k/Mese stabili ogni due settimane", ...EXTRA],
  },
  {
    id: 3,
    name: "Piano 3",
    duration: "3 Mesi",
    price: "€1.997",
    url: `${WA}trimestrale.`,
    featured: true,
    features: [BASE[0], "6 Call one-to-one da +1h30 l'una", ...BASE.slice(1), "Accesso One-to-Many avanzate con le Classi sopra i 5k/Mese stabili ogni settimana", "Call review", "Live analysis", "Live di Q&A", "Roleplay e Training personalizzati", ...EXTRA],
  },
];

// Piano 3 in centro
const ORDER = [PLANS[0], PLANS[2], PLANS[1]];

const ROWS = [
  ["Accesso a Skool + 200h di formazione", [true, true, true]],
  ["Call one-to-one da +1h30", ["4", "6", "6"]],
  ["Roadmap concreta", [true, true, true]],
  ["Affiancamento con personal coach", [true, true, true]],
  ["Garanzia sull'affiancamento eseguito", [true, true, true]],
  ["Classi One-to-Many sopra i 5k/Mese", [false, "Ogni due settimane", "Ogni settimana"]],
  ["Call review", [false, false, true]],
  ["Live analysis", [false, false, true]],
  ["Live di Q&A", [false, false, true]],
  ["Roleplay e Training personalizzati", [false, false, true]],
  ["Profilo personale sul portale di analisi", [true, true, true]],
  ["Sessioni private registrate, per sempre", [true, true, true]],
];

function Cell({ v }) {
  if (v === true) return <Check size={18} className="v-blue mx-auto" />;
  if (v === false) return <Minus size={16} className="mx-auto" style={{ color: "#4A4852" }} />;
  return <span className="v-ink" style={{ fontWeight: 600 }}>{v}</span>;
}

function CompareTable() {
  return (
    <section data-testid="offer-compare" className="mt-20 lg:mt-28">
      <h2 className="v-serif v-ink text-center" style={{ fontSize: "clamp(1.9rem, 4vw, 3rem)", fontWeight: 400 }}>
        Confronta i <span className="v-blue" style={{ fontStyle: "italic" }}>piani</span>
      </h2>
      <div className="v-card mt-10 overflow-hidden p-0">
        <table className="w-full table-fixed v-sans" style={{ borderCollapse: "collapse", fontSize: "clamp(0.72rem, 2.6vw, 0.95rem)" }}>
          <thead>
            <tr>
              <th className="w-[34%] sm:w-[40%] p-3 sm:p-5 text-left v-muted" style={{ fontWeight: 600 }}>Cosa include</th>
              {ORDER.map((p) => (
                <th key={p.id} data-testid={`compare-head-${p.id}`} className="p-3 sm:p-5 text-center v-ink" style={{ fontWeight: 700, ...(p.featured ? { background: "rgba(46,107,255,0.12)", borderBottom: "2px solid #2E6BFF" } : {}) }}>
                  {p.name}
                  <div className="v-muted mt-1" style={{ fontWeight: 500, fontSize: "0.85em" }}>{p.price}<br />{p.duration}</div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {ROWS.map(([label, vals]) => {
              const byId = { 1: vals[0], 2: vals[1], 3: vals[2] };
              return (
                <tr key={label} style={{ borderTop: "1px solid rgba(255,255,255,0.07)" }}>
                  <td className="p-3 sm:px-5 sm:py-4" style={{ color: "#C9C6CF" }}>{label}</td>
                  {ORDER.map((p) => (
                    <td key={p.id} className="p-2 sm:px-5 sm:py-4 text-center" style={p.featured ? { background: "rgba(46,107,255,0.08)" } : undefined}>
                      <Cell v={byId[p.id]} />
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
}

function PortalPreview() {
  return (
    <section data-testid="offer-portal" className="mt-20 lg:mt-28 text-center">
      <h2 className="v-serif v-ink" style={{ fontSize: "clamp(1.9rem, 4vw, 3rem)", fontWeight: 400 }}>
        Il tuo <span className="v-blue" style={{ fontStyle: "italic" }}>portale di analisi</span> dedicato
      </h2>
      <p className="v-muted mx-auto mt-4 max-w-[56ch]" style={{ fontSize: "1.02rem" }}>Profilo personale sul portale di analisi dedicato, incluso in tutti i piani.</p>
      <img src="/offer/portal.jpg" alt="Portale studente HighTicketSales.it — I Miei Progressi" loading="lazy" data-testid="offer-portal-screen" className="mt-10 block w-full h-auto rounded-2xl" style={{ border: "1px solid rgba(78,133,255,0.3)", boxShadow: "0 30px 80px rgba(0,0,0,0.55), 0 0 60px rgba(46,107,255,0.12)" }} />
    </section>
  );
}

function FreeTrial() {
  return (
    <section data-testid="offer-free-trial" className="relative mt-20 lg:mt-28 overflow-hidden rounded-2xl px-6 py-14 text-center sm:px-10 lg:py-20" style={{ background: "#00030F", border: "1px solid rgba(78,133,255,0.25)" }}>
      <div aria-hidden className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full" style={{ width: 560, height: 560, background: "radial-gradient(circle, rgba(46,107,255,0.18) 0%, rgba(46,107,255,0) 65%)" }} />
      <div className="relative">
        <h2 className="v-sans v-ink" style={{ fontWeight: 800, fontSize: "clamp(1.9rem, 5vw, 3.4rem)", lineHeight: 1.08, letterSpacing: "-0.02em" }}>
          Prova <span className="v-blue">GRATUITAMENTE</span> le sessioni
        </h2>
        <p data-testid="offer-free-trial-when" className="mt-6 inline-flex items-center gap-3 v-ink" style={{ fontSize: "clamp(1rem, 2.2vw, 1.2rem)", fontWeight: 600 }}>
          <span className="flex items-center justify-center rounded-full" style={{ width: 40, height: 40, border: "1px solid rgba(78,133,255,0.45)", background: "rgba(46,107,255,0.08)" }}>
            <CalendarDays size={18} strokeWidth={1.6} className="v-blue" />
          </span>
          Free ogni lunedì ore 20:00
        </p>
        <div className="mt-10 flex justify-center">
          <img src="/assets/74b541e1f123.jpg" alt="Canale Telegram HighTicketSales.it con 30 iscritti e 3 richieste di accesso" loading="lazy" data-testid="offer-free-trial-screen" className="block w-full max-w-[560px] h-auto rounded-2xl" style={{ border: "1px solid rgba(78,133,255,0.3)", boxShadow: "0 20px 50px rgba(0,0,0,0.5)" }} />
        </div>

        <div data-testid="offer-free-trial-selection" className="mx-auto mt-10 max-w-[560px] rounded-2xl px-6 py-6 text-left" style={{ background: "rgba(46,107,255,0.06)", border: "1px solid rgba(78,133,255,0.25)" }}>
          <p className="flex items-center gap-3 v-ink" style={{ fontWeight: 700, fontSize: "1.05rem" }}>
            <ShieldCheck size={20} strokeWidth={1.8} className="v-blue" /> C'è selezione all'ingresso
          </p>
          <ul className="mt-4 space-y-2.5" style={{ listStyle: "none", padding: 0 }}>
            {["No sales sotto i €2k/Mese", "No networker"].map((t) => (
              <li key={t} className="flex items-center gap-3" style={{ color: "#C9C6CF", fontSize: "1rem" }}>
                <X size={18} className="shrink-0" style={{ color: "#FF5A5A" }} /> {t}
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-10 flex justify-center">
          <a href="https://t.me/+T9sPHsLExsUxOTFk" target="_blank" rel="noopener noreferrer" onClick={() => trackTelegramClick("offer_entra_canale")} data-testid="offer-free-trial-cta" className="v-btn v-btn-blue btn-glow whitespace-nowrap px-7 py-4 sm:px-10 sm:py-[18px]" style={{ fontSize: "clamp(1rem, 3.6vw, 1.1rem)", borderRadius: 999, fontWeight: 700, textDecoration: "none" }}>
            Entra nel canale Telegram <ArrowRight size={20} />
          </a>
        </div>
      </div>
    </section>
  );
}

function PlanCard({ plan }) {
  const i = plan.id - 1;
  const f = plan.featured;
  return (
    <div className={`flex flex-col ${f ? "lg:-mt-6" : ""}`}>
    <div
      data-testid={`offer-plan-${i + 1}`}
      className="v-card relative flex flex-col p-7 lg:p-8 transition-transform duration-300 hover:-translate-y-1"
      style={f ? { border: "1.5px solid #2E6BFF", boxShadow: "0 0 0 4px rgba(46,107,255,0.10), 0 30px 80px rgba(46,107,255,0.25)" } : undefined}
    >
      <div className="flex items-center justify-between gap-3">
        <h2 className="v-sans v-ink" style={{ fontSize: "1.15rem", fontWeight: 700 }}>{plan.name}</h2>
        {f && <span data-testid="offer-plan-recommended" className="rounded-full px-3 py-1 text-xs font-bold text-white" style={{ background: "#2E6BFF" }}>Consigliato</span>}
      </div>
      <div className="mt-5 flex items-start gap-2">
        <span data-testid={`offer-plan-${i + 1}-price`} className="v-sans v-ink" style={{ fontSize: "clamp(2.4rem, 5vw, 3rem)", fontWeight: 800, lineHeight: 1, letterSpacing: "-0.02em" }}>{plan.price}</span>
      </div>
      <p className="mt-3 flex items-center gap-2" style={{ fontSize: "0.9rem" }}>
        <span data-testid={`offer-plan-${i + 1}-duration`} className="rounded-full px-3 py-1 v-ink" style={{ fontWeight: 700, background: "rgba(46,107,255,0.14)", border: "1px solid rgba(78,133,255,0.4)" }}>{plan.duration}</span>
        <span className="v-muted">Sales Mastery 1.0</span>
      </p>

      <a
        href={plan.url}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`offer-plan-${i + 1}-cta`}
        className={`v-btn mt-6 w-full ${f ? "v-btn-blue btn-glow" : "v-btn-ghost"}`}
        style={{ padding: "14px 20px", borderRadius: 999, textDecoration: "none" }}
      >
        Scrivimi su WhatsApp <ArrowRight size={18} />
      </a>

      <div className="my-6" style={{ borderTop: "1px solid rgba(255,255,255,0.08)" }} />
      <p className="v-blue v-sans" style={{ fontSize: "0.85rem", fontWeight: 700 }}>Cosa include:</p>
      <ul className="mt-4 space-y-3" style={{ listStyle: "none", padding: 0 }}>
        {plan.features.map((t) => (
          <li key={t} className="flex gap-3" style={{ fontSize: "0.95rem", color: "#C9C6CF", lineHeight: 1.45 }}>
            <Check size={18} className="v-blue mt-0.5 shrink-0" />
            <span>{t}</span>
          </li>
        ))}
      </ul>
    </div>
    <a
      href="/#live"
      data-testid={`offer-plan-${i + 1}-free-trial`}
      className="mx-auto mt-4 inline-flex items-center rounded-full px-4 py-1.5 transition-colors duration-200 hover:border-white/40 hover:text-white"
      style={{ border: "1px solid rgba(255,255,255,0.16)", background: "transparent", color: "#98959F", fontSize: "0.8rem", fontWeight: 500, textDecoration: "none" }}
    >
      Prova gratuitamente
    </a>
    </div>
  );
}

export default function OfferPage() {
  return (
    <div className="v-page" data-testid="offer-page">
      <div data-testid="offer-hero" className="relative overflow-hidden">
        <div aria-hidden className="pointer-events-none absolute inset-0" style={{ background: "url(/offer/space.jpg) center 30% / cover no-repeat", opacity: 0.55 }} />
        <div aria-hidden className="pointer-events-none absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(5,6,10,0.2) 0%, rgba(5,6,10,0.55) 60%, #05060A 100%)" }} />
        <header className="relative flex justify-center pt-6 pb-2">
          <a href="/" data-testid="offer-logo-link"><img src="/logo-hts.png" alt="HighTicketSales.it" style={{ height: 29, width: "auto" }} /></a>
        </header>
        <div className="relative mx-auto max-w-[1200px] px-4 pb-6 pt-10 text-center sm:pt-14 lg:px-10">
          <img src="/offer/sm-logo.jpg" alt="Sales Mastery 1.0 — Powered by HighTicketSales.it" data-testid="offer-sm-logo" className="mx-auto block w-full max-w-[520px] h-auto" style={{ mixBlendMode: "screen", WebkitMaskImage: "radial-gradient(ellipse 60% 48% at 50% 52%, #000 70%, transparent 100%)", maskImage: "radial-gradient(ellipse 60% 48% at 50% 52%, #000 70%, transparent 100%)" }} />
          <h1 className="v-serif v-ink mt-2" style={{ fontSize: "clamp(2.4rem, 6vw, 4.6rem)", lineHeight: 1.05, fontWeight: 400 }}>
            Scegli il tuo <span className="v-blue" style={{ fontStyle: "italic" }}>percorso</span>.
          </h1>
          <p className="v-muted mx-auto mt-5 max-w-[52ch]" style={{ fontSize: "1.05rem" }}>
            Tre pacchetti a durata fissa: 1, 2 o 3 mesi.
          </p>
        </div>
      </div>

      <main className="mx-auto max-w-[1200px] px-4 pb-24 pt-4 lg:px-10">

        <div className="mt-14 grid gap-5 lg:mt-20 lg:grid-cols-3 lg:items-start">
          {ORDER.map((p) => <PlanCard key={p.name} plan={p} />)}
        </div>

        <CompareTable />
        <PortalPreview />
        <FreeTrial />
      </main>

      <VslFooter />
    </div>
  );
}
